/**
 * BoxFrame mark: M2.T10c §13.12.
 *
 * Used for word-pick cards (wraps card content).
 * A wobbly hand-drawn rectangular frame.
 */
type BoxFrameProps = {
  width?: number;
  height?: number;
  strokeWidth?: number;
  /**
   * When true, omit intrinsic width/height attrs and set
   * `preserveAspectRatio="none"` so CSS can stretch the SVG to fit a
   * `position: absolute; inset: 0` container (used as a backdrop frame
   * around banners / cards). The width/height props still drive the
   * viewBox so callers pick the wobble's reference aspect.
   */
  stretch?: boolean;
};

export function BoxFrame({
  width = 120,
  height = 80,
  strokeWidth = 1.5,
  stretch = false,
}: BoxFrameProps) {
  const w = width;
  const h = height;
  // Four paths, one per side, each with a slight wobble
  const sizingProps = stretch ? { preserveAspectRatio: "none" as const } : { width: w, height: h };
  return (
    <svg class="mark-box-frame" viewBox={`0 0 ${w} ${h}`} aria-hidden="true" {...sizingProps}>
      {/* Top edge */}
      <path
        d={`M 4 2 C 20 1 50 3 ${w - 4} 2`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Right edge */}
      <path
        d={`M ${w - 2} 4 C ${w - 1} 20 ${w - 3} 50 ${w - 2} ${h - 4}`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Bottom edge */}
      <path
        d={`M ${w - 4} ${h - 2} C 50 ${h - 1} 20 ${h - 3} 4 ${h - 2}`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Left edge */}
      <path
        d={`M 2 ${h - 4} C 1 50 3 20 2 4`}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
